import type { IconName } from "@calcom/ui/components/icon";
import { Icon } from "@calcom/ui/components/icon";

interface AnnouncementBannerProps {
  announcement: string | null | undefined;
  announcementColor?: string | null;
  announcementIcon?: string | null;
}

const colorStyles: Record<string, { wrapper: string; text: string; icon: string }> = {
  amber:  { wrapper: "bg-[#451a03] border border-[#92400e]", text: "text-[#fcd34d]", icon: "text-[#f59e0b]" },
  red:    { wrapper: "bg-[#450a0a] border border-[#7f1d1d]", text: "text-[#fca5a5]", icon: "text-[#ef4444]" },
  orange: { wrapper: "bg-[#431407] border border-[#9a3412]", text: "text-[#fdba74]", icon: "text-[#f97316]" },
  green:  { wrapper: "bg-[#052e16] border border-[#14532d]", text: "text-[#86efac]", icon: "text-[#22c55e]" },
  blue:   { wrapper: "bg-[#0a1628] border border-[#1e3a5f]", text: "text-[#93c5fd]", icon: "text-[#3b82f6]" },
  purple: { wrapper: "bg-[#1a0a2e] border border-[#4c1d95]", text: "text-[#d8b4fe]", icon: "text-[#a855f7]" },
  pink:   { wrapper: "bg-[#2e0a1a] border border-[#831843]", text: "text-[#f9a8d4]", icon: "text-[#ec4899]" },
  cyan:   { wrapper: "bg-[#031b1e] border border-[#164e63]", text: "text-[#67e8f9]", icon: "text-[#06b6d4]" },
  gray:   { wrapper: "bg-[#1f2937] border border-[#374151]", text: "text-[#f9fafb]", icon: "text-[#9ca3af]" },
};

export function AnnouncementBanner({ announcement, announcementColor, announcementIcon }: AnnouncementBannerProps) {
  if (!announcement?.trim()) return null;

  const color = announcementColor && colorStyles[announcementColor] ? announcementColor : "amber";
  const styles = colorStyles[color];
  const iconName = (announcementIcon || "triangle-alert") as IconName;

  return (
    <div className={`mb-2 flex items-start gap-2 rounded-md px-3 py-2 ${styles.wrapper}`}>
      <Icon name={iconName} className={`mt-0.5 h-4 w-4 shrink-0 ${styles.icon}`} />
      <span className={`text-sm font-medium leading-snug whitespace-pre-wrap ${styles.text}`}>
        {announcement}
      </span>
    </div>
  );
}
